import { RelativeSpinner } from '../RelativeSpinner';

type TProps = {
  overlay?: boolean;
  className?: string;
};

export const RelativeSpinner65 = ({ overlay, className }: TProps) => (
  <div className={['relative isolate z-0 h-[65px] w-[65px] shrink-0', className].filter(Boolean).join(' ')}>
    <RelativeSpinner className="relative h-full w-full" overlay={overlay} />
  </div>
);
